"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionsSheetContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const analytics_1 = require("@completeanatomy/analytics");
const auth_1 = require("@completeanatomy/auth");
const device_1 = require("@completeanatomy/device");
const inapp_store_1 = require("@completeanatomy/inapp-store");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const NavigationBar_1 = require("../../molecules/NavigationBar/NavigationBar");
const StickyFooter_1 = __importDefault(require("../../molecules/StickyFooter/StickyFooter"));
const bridge_1 = require("@completeanatomy/bridge");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const i18n_1 = require("@completeanatomy/i18n");
const licenses_1 = require("@completeanatomy/licenses");
const storage_1 = require("@completeanatomy/storage");
const store_1 = require("@completeanatomy/store");
const user_1 = require("@completeanatomy/user");
const react_router_dom_1 = require("react-router-dom");
const withDelayedAppearance_1 = require("../../hocs/withDelayedAppearance");
const SubscriptionsSheetScreen_1 = require("../SubscriptionsSheetScreen/SubscriptionsSheetScreen");
// eslint-disable-next-line max-lines-per-function
function SubscriptionsSheetContent() {
    var _a, _b, _c, _d, _e;
    const analytics = (0, analytics_1.useAnalytics)();
    const auth = (0, auth_1.useAuth)();
    const bridge = (0, bridge_1.useBridge)();
    const inappStore = (0, inapp_store_1.useInappStore)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { t } = (0, i18n_1.useTranslation)();
    const storage = (0, storage_1.useStorageService)();
    const user = (0, user_1.useUser)();
    const isCN = (0, device_1.useIsCNRegion)();
    const { isMobile, isDesktop, isWindows } = (0, device_1.usePlatform)();
    const isLandscape = (0, ui_1.useOrientation)();
    const defaultStuLicense = {
        type: 0,
        isPurchased: false,
        isRecommended: false,
    };
    const defaultProLicense = {
        type: 3,
        isPurchased: false,
        isRecommended: false,
    };
    const store = (0, store_1.useStoreState)();
    (0, react_1.useEffect)(() => {
        //@ts-ignore
        window.accessController.requestProducts();
    }, []);
    const studentLicense = (_b = (_a = store === null || store === void 0 ? void 0 : store.licenses) === null || _a === void 0 ? void 0 : _a.studentPlus) !== null && _b !== void 0 ? _b : defaultStuLicense;
    const proLicense = (_d = (_c = store === null || store === void 0 ? void 0 : store.licenses) === null || _c === void 0 ? void 0 : _c.pro) !== null && _d !== void 0 ? _d : defaultProLicense;
    const licenses = {
        studentPlus: studentLicense,
        pro: proLicense,
    };
    const userLicenses = (0, licenses_1.useUserLicenses)();
    const isLoggedIn = (user === null || user === void 0 ? void 0 : user.identifier) !== undefined;
    const hasActiveTrial = (_e = (0, licenses_1.isTrialLicenses)(userLicenses)) !== null && _e !== void 0 ? _e : false;
    const isTrialFinished = isLoggedIn && userLicenses && !hasActiveTrial;
    const [surveyData, setSurveyData] = (0, react_1.useState)(undefined);
    const [selectedLicense, setSelectedLicense] = (0, react_1.useState)(defaultStuLicense);
    const [recommendedLicense, setRecommendedLicense] = (0, react_1.useState)(defaultStuLicense);
    const [isShowTableView, setIsShowTableView] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        const fetchViewState = () => __awaiter(this, void 0, void 0, function* () {
            const showPurchaseView = yield (storage === null || storage === void 0 ? void 0 : storage.get('shouldShowSubscriptionPurchase'));
            setIsShowTableView(showPurchaseView !== 'true');
        });
        fetchViewState();
    }, [storage]);
    (0, react_1.useEffect)(() => {
        const fetchData = () => __awaiter(this, void 0, void 0, function* () {
            const data = yield (storage === null || storage === void 0 ? void 0 : storage.get('newUserSurvey'));
            setSurveyData(data);
            //Flag Clean-up: when user logs in -> gets navigated by handler && does not qualify for subsheets.
            const showSubscriptionSheet = yield (storage === null || storage === void 0 ? void 0 : storage.get('shouldShowSubscriptionSheet'));
            const shouldCallOnBuy = yield (storage === null || storage === void 0 ? void 0 : storage.get('shouldCallOnBuy'));
            const showCallRestorePurchase = yield (storage === null || storage === void 0 ? void 0 : storage.get('shouldCallRestorePurchase'));
            const hasSubsheetCall = shouldCallOnBuy === 'true' || showCallRestorePurchase === 'true';
            const hasCurrentSubscription = (user === null || user === void 0 ? void 0 : user.identifier) &&
                userLicenses &&
                userLicenses.length > 0 &&
                !(0, licenses_1.isTrialLicenses)(userLicenses);
            if (showSubscriptionSheet === 'true' &&
                hasCurrentSubscription &&
                !hasSubsheetCall) {
                storage === null || storage === void 0 ? void 0 : storage.put('shouldShowSubscriptionSheet', 'false');
            }
        });
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [storage, user === null || user === void 0 ? void 0 : user.identifier]);
    (0, react_1.useEffect)(() => {
        /** StoreState License Types to SurveyData User Kinds Types --
        /*  - Student = 0   => 'STUDENT [3], ENTHUSIAST [5]'.
        /*  - Pro = 3       => 'ALT PRAC [2], HEALTHCARE PROV [2], ACADEMIC [1]'.
        */
        const isUserStudent = (user === null || user === void 0 ? void 0 : user.kind) === 'Student' || (user === null || user === void 0 ? void 0 : user.kind) === 'Enthusiast';
        const isSurveyStudent = (surveyData === null || surveyData === void 0 ? void 0 : surveyData.type) === 3 || (surveyData === null || surveyData === void 0 ? void 0 : surveyData.type) === 5;
        const recommended = isUserStudent || isSurveyStudent ? studentLicense : proLicense;
        setRecommendedLicense(recommended);
        setSelectedLicense(recommended);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user === null || user === void 0 ? void 0 : user.kind, surveyData, storage, store === null || store === void 0 ? void 0 : store.licenses]);
    const onShowLoginClick = () => {
        auth === null || auth === void 0 ? void 0 : auth.authenticate();
        navigate(`${auth_1.Route.Base}/${auth_1.Route.InterimScreen}/${auth_1.Route.InterimScreenOpen}`, { state: { process: auth_1.AuthProcess.SignIn } });
    };
    const onBuy = (0, react_1.useCallback)((license) => __awaiter(this, void 0, void 0, function* () {
        if (!(license === null || license === void 0 ? void 0 : license.product))
            return;
        inappStore === null || inappStore === void 0 ? void 0 : inappStore.sendSubscriptionAddedToCartEvent(license === null || license === void 0 ? void 0 : license.product);
        if (isWindows) {
            let link = '';
            switch (license.type) {
                case bridge_schema_1.LicenseType.StudentPlus:
                    link =
                        'https://store.3d4medical.com/checkout/student?promo=windows';
                    break;
                case bridge_schema_1.LicenseType.Pro:
                    link = 'https://store.3d4medical.com/checkout/pro?promo=windows';
                    break;
                default:
                    break;
            }
            if (isCN) {
                link = link.replace('3d4medical.com', 'completeanatomy.cn');
            }
            bridge === null || bridge === void 0 ? void 0 : bridge.openURL({ link });
            storage === null || storage === void 0 ? void 0 : storage.put('shouldShowSubscriptionSheet', 'false');
            return;
        }
        storage === null || storage === void 0 ? void 0 : storage.put('shouldCallOnBuy', 'true');
        try {
            const response = 
            // @ts-ignore
            yield window.Manager.InAppPurchaseManager.purchaseProductWithOptions({
                productIdentifier: license.product.identifier,
            });
            // @ts-ignore
            if (response === null || response === void 0 ? void 0 : response.success) {
                storage === null || storage === void 0 ? void 0 : storage.put('shouldShowSubscriptionSheet', 'false');
                storage === null || storage === void 0 ? void 0 : storage.put('shouldCallOnBuy', 'false');
                navigate(`/hub`);
            }
        }
        catch (e) {
            console.error('Error purchasing license:', e);
        }
    }), [storage, inappStore, navigate, isCN, bridge, isWindows]);
    const onBuyClick = () => {
        if (isShowTableView) {
            analytics.log('UnlockAppBuyNowPressed');
            storage === null || storage === void 0 ? void 0 : storage.put('shouldShowSubscriptionPurchase', 'true');
            setIsShowTableView(false);
        }
        else if (selectedLicense) {
            analytics.log('PricingConfirmPayPressed');
            onBuy(selectedLicense);
        }
    };
    const onTrialClick = () => {
        analytics.log('UnlockAppTryItFreePressed');
        storage === null || storage === void 0 ? void 0 : storage.put('shouldShowSubscriptionSheet', 'false');
        if (hasActiveTrial) {
            navigate('/hub');
        }
        else {
            auth === null || auth === void 0 ? void 0 : auth.signUp();
            navigate(`${auth_1.Route.Base}/${auth_1.Route.InterimScreen}/${auth_1.Route.InterimScreenOpen}`, { state: { process: auth_1.AuthProcess.Register } });
        }
    };
    const onBackClick = () => {
        setIsShowTableView(true);
        storage === null || storage === void 0 ? void 0 : storage.put('shouldShowSubscriptionPurchase', 'false');
        setSelectedLicense(recommendedLicense);
    };
    const onCloseClick = () => {
        isShowTableView
            ? analytics.log('UnlockAppClosePressed')
            : analytics.log('PricingClosePressed');
        storage === null || storage === void 0 ? void 0 : storage.put('shouldShowSubscriptionSheet', 'false');
        navigate(`/hub`);
    };
    return ((0, jsx_runtime_1.jsxs)(Container, { isLandscape: isLandscape, isMobile: isMobile, "data-e2e": 'SubscriptionsSheetContent_Container', children: [(0, jsx_runtime_1.jsx)(NavigationContent, { isLandscape: isLandscape, isMobile: isMobile, "data-e2e": 'SubscriptionsSheetContent_NavigationContent', children: (0, jsx_runtime_1.jsx)(NavigationBar_1.NavigationBar, { showBackArrow: !isShowTableView, onBackClick: onBackClick, onCloseClick: onCloseClick, isMobile: isMobile, isLandscape: isLandscape, "data-e2e": 'SubscriptionsSheetContent_NavigationBar' }) }), (0, jsx_runtime_1.jsx)(MainContent, { "data-e2e": 'SubscriptionsSheetContent_MainContent', children: (0, jsx_runtime_1.jsx)(SubscriptionsSheetScreen_1.SubscriptionsSheetScreen, { isActiveTrial: hasActiveTrial, isDesktop: isDesktop, isLandscape: isLandscape, isMobile: isMobile, isShowTable: isShowTableView, t: t, onShowLoginClick: onShowLoginClick, onBuyClick: onBuyClick, recommendedLicense: recommendedLicense, selectedLicense: selectedLicense, onSetSelectedLicense: setSelectedLicense, licenses: licenses, "data-e2e": 'SubscriptionsSheetContent_SubscriptionsSheetScreen' }) }), (0, jsx_runtime_1.jsxs)(FooterContent, { isMobile: isMobile, isLandscape: isLandscape, "data-e2e": 'SubscriptionsSheetContent_FooterContent', children: [(0, jsx_runtime_1.jsx)(FooterGradient, { "data-e2e": 'SubscriptionsSheetContent_FooterGradient' }), (0, jsx_runtime_1.jsx)(StickyFooter_1.default, { dualBtn: isShowTableView && !isTrialFinished, isShowTable: isShowTableView, isActiveTrial: hasActiveTrial, isMobile: isMobile, isLandscape: isLandscape, t: t, handleBuyClick: onBuyClick, handleTrialClick: onTrialClick, "data-e2e": 'SubscriptionsSheetContent_StickyFooter' })] })] }));
}
exports.SubscriptionsSheetContent = SubscriptionsSheetContent;
exports.default = (0, storage_1.withStorageProvider)((0, inapp_store_1.withInappStoreProvider)((0, withDelayedAppearance_1.withDelayedAppearance)(SubscriptionsSheetContent, 300, 200)));
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  gap: 1em;
  background-color: #11151c;

  max-width: 100vw;
  max-height: 100vh;

  ${({ isMobile }) => isMobile && `gap: 0;`};

  ${({ isMobile, isLandscape }) => isMobile && isLandscape && `display: block;`};
`;
const NavigationContent = styled_components_1.default.div `
  z-index: 5;
  align-items: center;
  height: 34px;

  ${({ isMobile, isLandscape }) => {
    if (isMobile && !isLandscape) {
        return `
        position: sticky;
        top: 0px;
        padding: 0px;
        background-color: #11151c;
      `;
    }
    else if (isLandscape) {
        return isMobile
            ? `
        width: 93%;
        position: fixed;
        right: 40px;
        top: 40px;
      `
            : `
        width: 100%;
        position: fixed;
        right: 0px;
        top: 0px;
      `;
    }
}};
`;
const MainContent = styled_components_1.default.div `
  z-index: 0;
`;
const FooterGradient = styled_components_1.default.div `
  height: 32px;
  background-image: linear-gradient(
    to bottom,
    rgba(17, 21, 28, 0),
    rgba(17, 21, 28) 120%
  );
`;
const FooterContent = styled_components_1.default.div `
  z-index: 20;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  max-width: 100vw;

  ${({ isMobile, isLandscape }) => {
    if (isMobile && isLandscape) {
        return `
        margin: 0;
        height: 160px;
      `;
    }
    else if (isMobile && !isLandscape) {
        return `
        margin: 3em 0;
        height: 196px;
      `;
    }
}}
`;
